import React, { useRef, useEffect } from "react";
import DOMPurify from "dompurify";

export default function A4SizeContact({ value }) {
  const contentRef = useRef(null);

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const decodedValue = DOMPurify.sanitize(decodeHtml(value || ""));

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [decodedValue]);

  return (
    <div className="description-sec-p">
      <style>
        {`
          .custom-html {
          
            padding: 16px 20px;       /* INNER SPACE */
            margin-top: 12px;         /* OUTER SPACE */
            border: 1px solid #ddd;
            border-radius: 6px;
            background: #fff;
          }

          .custom-html p,
          .custom-html h1,
          .custom-html h2,
          .custom-html h3,
          .custom-html h4,
          .custom-html h5,
          .custom-html h6 {
            color: #000 !important;
            margin-bottom: 10px;
          }

          .custom-html ul,
          .custom-html ol {
            margin: 6px 0 10px 20px;
            padding-left: 18px;
          }

          .custom-html li {
            margin-bottom: 6px;
            list-style-position: outside;
          }

          .custom-html ul li {
            list-style-type: disc;
          }

          .custom-html ol li {
            list-style-type: decimal;
          }

          .custom-html * {
            box-sizing: border-box;
          }

          
          .custom-html p{
          margin-left:0 !important;
          }
        `}
      </style>

      {value && (
        <div
          ref={contentRef}
          className="custom-html"
          dangerouslySetInnerHTML={{ __html: decodedValue }}
        />
      )}
    </div>
  );
}
